{
  "section_table": {
    "caption": "Company locations",
    "search": "Search locations",
    "inherited": "Inherited",
    "headings": {
      "name": "Location",
      "customer_group": "Customer group",
      "price_lists": "Price lists",
      "company_users": "Customers",
      "current_balance": "Balance",
      "admins": "Location admins"
    },
    "actions": {
      "add_child": "Add sub-location"
    }
  },
  "section_form": {
    "move_node": "Change current position",
    "parent": {
      "title": "Placement",
      "description": "Where this location sits in the company hierarchy. It inherits the settings of everything above it.",
      "label": "Parent location",
      "top_level": "Top level (directly under the company)",
      "top_level_named": "Top level (directly under {company})"
    },
    "sibling": {
      "label": "Position under parent",
      "description": "This location will be placed before the chosen option.",
      "last_label": "Bottom of list"
    }
  },
  "section_customers": {
    "title": "Customers",
    "description": "The company's customers who belong to this location, and what each one can do.",
    "select_label": "Assigned customers",
    "role_list_error": "We couldn't load the list of roles. Roles can't be changed until it loads.",
    "non_leaf": {
      "title": "This location has sub-locations",
      "description": "Customers can only belong to a location at the bottom of the hierarchy. Assign them to one of this location's sub-locations instead."
    },
    "table": {
      "caption": "Customers assigned to this location",
      "headings": {
        "customer": "Customer",
        "role": "Role"
      }
    }
  },
  "section_admins": {
    "title": "Admins",
    "description": "Customers who look after this location and every location below it. They can see and approve every order placed there.",
    "select_label": "Location admins"
  }
}
